import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Crown } from "lucide-react";

export function FoundingPill() {
  const [slots, setSlots] = useState(null);

  useEffect(() => {
    api.get("/founding/count").then((r) => setSlots(r.data)).catch(() => {});
  }, []);

  if (!slots) return null;
  if (slots.remaining <= 0) return null;

  const critical = slots.remaining <= slots.max * 0.3;
  return (
    <div
      data-testid="founding-pill"
      className="inline-flex items-center gap-2 border border-white/25 backdrop-blur-md bg-white/5 px-4 py-2 text-[11px] tracking-[0.2em] uppercase text-white/85"
    >
      <Crown size={12} strokeWidth={1.5} className={critical ? "text-amber-300" : "text-white/70"} />
      <span className="text-white/60">Founding</span>
      <span className={critical ? "text-amber-200 font-medium" : "text-white font-medium"}>
        {slots.remaining}/{slots.max}
      </span>
      <span className="text-white/50">a {slots.current_price.toFixed(0)}€</span>
    </div>
  );
}
